export default {
  setUnitWorkPlaces(state, value) {
    state.unitWorkPlace = value
  },
  setLoadingWorkPlaceServiceCategories(state, payload) {
    state.isLoadingWorkPlaceServiceCategories = payload
  },
}
